import * as userActions from '@redux/modules/userV4'

import usePaginatedLoader from './usePaginatedLoader'

function useUsersV4(options = {}){
  const { searchFilter, selectedRoles, selectedFlags } = options

  const { items: filteredUsersV4, loading, hasMore, callbacks } = usePaginatedLoader({
    loadFn: userActions.loadUsersV4,
    entityKey: 'usersV4',
    queryOptions: {
      name: searchFilter || '',
      roles: selectedRoles,
      ...selectedFlags?.length && { flags: selectedFlags },
    },
  })

  return { filteredUsersV4, loading, hasMore, callbacks }
}

export default useUsersV4
